import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { FLOW } from 'app/model/adapters/dataflow/IDataflow';
import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { UnionTransformation } from 'app/model/dataflow/uniontransformation';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(UnionTransformation),
    asynchronous: true
})
export class UnionTransformationAdapter extends TransformationAdapter<UnionTransformation> {
    public async getDslScript(unionTransformation: UnionTransformation): Promise<string> {
        const unionExpression = `byName: ${unionTransformation.byName}`;
        const partition = TransformationAdapter.getPartitionDslScript(unionTransformation);

        const knownProps = [unionExpression, partition].filter((c) => !!c).join(',\n\t');
        const unknownProps = this._getUnknownProps(unionTransformation, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');

        return (
            `${this._getInputStreams(unionTransformation)} ${UnionTransformation.MODEL.name}(${transformationData})` +
            `${FLOW} ${this._getOutputStreams(unionTransformation)}`
        );
    }
}
